export const capitalize = (text) => {
  let cuteText = text
    ?.toLowerCase()
    ?.replace(/(?:^|\s|['`‘’?-])[^-\x60^\x7B-\xDF](?!(\s|$))/g, (a) => {
      return a?.toUpperCase();
    });
  return cuteText;
};
